import { useTranslation } from 'i18n';
import { Chip } from 'ui';

export const SelfServeChip = () => {
  const { t } = useTranslation('features');

  return <Chip size="small" color="warning" label={t('evidence.chips.selfServe')} />;
};
